import React from "react";
import PageTitle from "../components/PageTitle";
import { connect } from "react-redux";
import { settings, settingsLoadInProgress } from "../selectors/global-settings";
import { settingsPageLoad } from "../actions/global-settings";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";

export default connect(
  (state, ownProps) => ({
    globalSettings: settings(state),
    loading: settingsLoadInProgress(state),
  }),
  (dispatch, ownProps) => ({
    onLoad: () => dispatch(settingsPageLoad()),
  }),
)(
  componentWithLoadTrigger(props => {
    if (props.loading) {
      return <PageTitle title="Loading..." />;
    }
    const emailTo = `mailTo:${props.globalSettings.adminContactEmail}`;
    return (
      <div id="contact-page">
        <PageTitle title="Contact info" />
        <div>
          <p>
            <strong>
              Contact information for{" "}
              <span id="partner-name">{props.globalSettings.partnerName}</span>.
            </strong>
          </p>
          <p>
            To request a change to the on-call schedule, please contact your
            Administrator:
          </p>
          <p>
            <strong>{props.globalSettings.adminContactName}</strong>
            <br />
            <a href={emailTo}>
              <strong>{props.globalSettings.adminContactEmail}</strong>
            </a>
          </p>
          <p>
            To report an issue with the site, please email your SecurityCoverage
            account manager:
          </p>
          <p>
            <a href="mailto:partners@securitycoverage.com">
              <strong>partners@securitycoverage.com</strong>
            </a>
          </p>
        </div>
      </div>
    );
  }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/ContactPage.js